var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('footer',{staticClass:"main-footer div-home"},[_c('div',{staticClass:"container"},[_c('footer-widgets')],1),_c('footer-copyright')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }